import { render, staticRenderFns } from "./DatetimeApprovals.vue?vue&type=template&id=46fd74a0"
import script from "./DatetimeApprovals.vue?vue&type=script&lang=js"
export * from "./DatetimeApprovals.vue?vue&type=script&lang=js"
import style0 from "./DatetimeApprovals.vue?vue&type=style&index=0&id=46fd74a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports